module.exports = __webpack_public_path__ + "static/media/bear_3.fbcb0141.jpg";